module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r_banner"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("爱乐")])]), _vm._v(" "), _c('span', {
    staticClass: "bigtitle"
  }, [_vm._v("爱乐")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.xinfo.banner7url,
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587eaf59"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rangeDetails/banner.vue
// module id = 263
// module chunks = 0